import { ToggleSize } from './Toggle.types';

type ToggleConstsProps = {
  [size in ToggleSize]: {
    width: number;
    height: number;
    labelFontSize: number;
    labelLineHeight: number;
    circle: {
      size: number;
      onPosition: number;
      offset: number;
    };
  };
};

export const toggleConsts: ToggleConstsProps = {
  xsmall: {
    width: 20,
    height: 12,
    labelFontSize: 11,
    labelLineHeight: 16,
    circle: {
      size: 8,
      onPosition: 8,
      offset: 2,
    },
  },
  small: {
    width: 28,
    height: 16,
    labelFontSize: 11,
    labelLineHeight: 18,
    circle: {
      size: 12,
      onPosition: 12,
      offset: 2,
    },
  },
  medium: {
    width: 44,
    height: 24,
    labelFontSize: 14,
    labelLineHeight: 20,
    circle: {
      size: 20,
      onPosition: 20,
      offset: 2,
    },
  },
  large: {
    width: 56,
    height: 28,
    labelFontSize: 16,
    labelLineHeight: 24,
    circle: {
      size: 24,
      onPosition: 28,
      offset: 2,
    },
  },
};
